import axios from 'axios';
import { AdebifyApi as Api } from 'services/api/Api';

export const getAccountMapping = (params) =>
  Api.get('/settings/account-mapping', { params });

export const getConversions = () =>
  Api.get('/settings/conversions');

export const saveAccountMapping = (mappingId, data) =>
  mappingId
    ? Api.put(`/settings/account-mapping/${mappingId}`, data)
    : Api.post('/settings/account-mapping', data);

export const getLtvDetail = (params) =>
  Api.post('/reports/ltv-detail', params);

export const getLtvCohort = (params) =>
  Api.post('/reports/ltv-cohort', params);

export const getProductAnalysis = (params) =>
  Api.post('/reports/product-analysis', params);

export const getCustomReport = (params) =>
  Api.post('/reports/custom-report', params);

export const getReportPresets = (params) =>
  Api.get('/settings/report-presets', { params });

export const createReportPreset = (data) =>
  Api.post('/settings/report-presets', data);

export const updateReportPreset = (id, data) =>
  Api.put(`/settings/report-presets/${id}`, data);

export const deleteReportPreset = (id) =>
  Api.delete(`/settings/report-presets/${id}`);

export const getDisplayItems = (funcId) =>
  Api.get(`/settings/display-items/${funcId}`);

export const saveDisplayItems = (funcId, data) =>
  Api.post(`/settings/display-items/${funcId}`, data);

export const exportCsv = (data) =>
  Api.post('/reports/export-csv', data);

export const testShopifyConnection = (data) =>
  Api.post('/settings/shopify-connection-test', data);

export const uploadAdProductMaster = async (file) => {
  // Step 1: Get presigned S3 upload URL
  const urlResponse = await Api.get('/settings/upload-url', {
    params: { upload_type: 'ad_product_master' },
  });
  const { upload_url: uploadUrl, s3_key: s3Key } = urlResponse.data?.data || urlResponse.data;

  // Step 2: Upload CSV directly to S3 via presigned PUT URL
  await axios.put(uploadUrl, file, {
    headers: { 'Content-Type': 'text/csv' },
  });

  // Step 3: Notify backend to process the uploaded file
  return Api.post('/settings/ad-product-master', {
    s3_key: s3Key,
    filename: file.name || 'ad_product_master.csv',
  });
};

export const getUploadHistory = (uploadType) =>
  Api.get('/settings/upload-history', { params: { upload_type: uploadType } });

export const uploadCostMaster = async (file) => {
  // Step 1: Get presigned S3 upload URL
  const urlResponse = await Api.get('/settings/upload-url', {
    params: { upload_type: 'cost_master' },
  });
  const { upload_url: uploadUrl, s3_key: s3Key } = urlResponse.data?.data || urlResponse.data;

  // Step 2: Upload CSV directly to S3 via presigned PUT URL
  await axios.put(uploadUrl, file, {
    headers: { 'Content-Type': 'text/csv' },
  });

  // Step 3: Notify backend to process the uploaded file
  return Api.post('/settings/cost-master', {
    s3_key: s3Key,
    filename: file.name || 'cost_master.csv',
  });
};
